import store from "../../../store/store"
export const componentKey = 'ADD_PATIENT'

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setCreatePatientData: (state, action) => {
            state.createPatientData = { ...state.createPatientData, ...action.payload }
        },
        setIsAadharProvided: (state, action) => {
            state.isAadharProvided = action.payload;
        },
        setProviderGroupLocation: (state, action) => {
            state.providerGroupLocation = action.payload;
        },
        setEmergencyContact: (state, action) => {
            state.emergencyContact = action.payload;
        },
        setInsurance: (state, action) => {
            state.emergencyContact = action.payload;
        },
        setPreferencesOptions: (state, action) => {
            const { name, data = [] } = action.payload
            switch (name) {
                case "pharmacy":
                    state.pharmacies = data
                    break;
                case "lab":
                    state.labs = data
                    break;
                case "radiology":
                    state.radiologies = data
                    break;
                default:
                    break;
            }
        },
        setIsOpenAddCenterModal: (state, action) => {
            state.isOpenAddCenterModal = action.payload;
        },
        setCreatePatientSuccessData: (state, action) => {
            state.createPatientSuccessData = action.payload;
        },
        setNewlyAddedPatientId: (state, action) => {
            state.newlyAddedPatientId = action.payload;
        },
        setFetchedPatientDetails: (state, action) => {
            state.fetchedPatientDetails = action.payload;
        },
        setFetchedEmergencyContactDetails: (state, action) => {
            state.fetchedEmergencyContactDetails = action.payload;
        },
        setIsFormSubmitted: (state, action) => {
            state.isFormSubmitted = { ...state.isFormSubmitted, ...action.payload }
        },
        setIsOpenAddInsuranceModal: (state, action) => {
            state.isOpenAddInsuranceModal = action.payload
        },
        setDeviceNamesList: (state, action) => {
            state.deviceNamesList = action.payload
        },
        setIsRedirectedFromDemographics: (state, action) => {
            state.isRedirectedFromDemographics = action.payload
        },
        setEditDemographicsData: (state, action) => {
            state.editDemographicsData = { ...state.editDemographicsData, ...action.payload }
        },
        setDeviceTestList: (state, action) => {
            state.deviceTestList = action.payload
        },
        setTransactionIdAndAadhaar:(state, action)=>{
            state.transactionIdAndAadhaar = action.payload
        },
        setCreateABHApatientRespose: (state, action) => {
            state.createABHAPatientResponse = action.payload
        },
        setOpenImportABHADetailsModal:(state, action) => {
            state.openImportABHADetailsModal = action.payload
        },
        setOpenGetOrCreatePatientModal: (state, action) => {
            state.openGetOrCreatePatientModal = action.payload
        },
        setIsCreateABHA: (state, action) => {
            state.isCreateABHA = action.payload
        },
        setOpenValidateGetOtpModal:(state, action)=>{
            state.openValidateGetOtpModal = action.payload
        },
        setOpenValidateCreateOtpModal:(state, action)=>{
            state.openValidateCreateOtpModal = action.payload
        },
        setOpenSelectPatientModal: (state, action) => {
            state.openSelectPatientModal = action.payload
        },
        setPatientsList: (state, action) => {
            state.patientsList = action.payload
        },
        setClearOtpOrMobile:(state, action) => {
            state.clearOtpOrMobile = action.payload
        },
        setOpenUpdateABHAValidateOtpModal:(state, action) => {
            state.openUpdateABHAValidateOtpModal = action.payload
        },
        setPatientDetailsReviewLocation: (state, action) => {
            state.patientDetailsReviewLocation = action.payload
        },
        setOpenABHACreateSuccessPopup:(state, action) => {
            state.openABHACreateSuccessPopup = action.payload
        },
        setStartTimer: (state, action) => {
            state.startTimer = action.payload
        },
        setCreatePatientFromAadhaar:(state, action)=>{
            state.createPatientFromAadhaar = action.payload
        },
        setABHAsuggestedAddress: (state, action) => {
            state.abhaSuggestedAddress = action.payload
        },
        setABHASuggestionsOpen: (state, action) => {
            state.abhaSuggestionsOpen = action.payload
        },
        setABHAAddressUpdateOpen: (state, action) => {
            state.abhaAddressUpdateOpen = action.payload
        },
        setSelectedABHAAddress : (state, action) => {
            state.selectedABHAAddress = action.payload
        },
        setUpdatedABHAEmail: (state, action) => {
            state.updatedABHAEmail = action.payload
        },
        setUpdatedABHAMobile: (state, action) => {
            state.updatedABHAMobile = action.payload
        },
        setABHAProfilePicture: (state, action) => {
            state.abhaProfilePicture =  action.payload
        },
        setDownloadedCard: (state, action) => {
            state.downloadedCardBuffer = action.payload;
        },
        setSelectedABHAOption: (state, action)=>{
            state.selectedABHAOption = action.payload
        },
        setSelectedPatient: (state, action)=>{
            state.selectedPatient = action.payload
        },
        setShowValidateMobileModal:(state, action)=>{
            state.showValidateMobileModal = action.payload
        },
        setMobileNumberToLink: (state, action)=>{
            state.mobileNumberToLink = action.payload
        },
        setIsVerified: (state, action)=>{
            state.isVerified = action.payload
        },
        setShowChooseAbhaAddressModal: (state, action)=>{
            state.showChooseAbhaAddressModal = action.payload
        },
        setOpenConsentForm: (state, action)=>{
            state.openConsentForm = action.payload
        },
        setAdhaarOtpMsg: (state, action)=>{
            state.adhaarOtpMsg = action.payload
        },
        setScanAndShareProviderId:(state,action)=>{
            state.createPatientFromScanAndShareProviderId=action.payload
        },
        setCaptchaData: (state, action) => {
            state.captchaData = action.payload
        },
        setIsAadharExist:(state,action)=>{
            state.isAddharExist=action.payload;
        }
    },
    initialReducerState: {
        createPatientData: {},
        isAadharProvided: true,
        providerGroupLocation: [],
        emergencyContact: [],
        insurance: [],
        pharmacies: [],
        labs: [],
        radiologies: [],
        isOpenAddCenterModal: false,
        createPatientSuccessData: {},
        newlyAddedPatientId: "",
        fetchedPatientDetails: {},
        fetchedEmergencyContactDetails: {},
        isFormSubmitted: {
            providerInformation: false,
            patientDetails: false,
            contactInformation: false,
            emergencyContact: false,
            insurance: false,
            preferences: false,
            privacyConsent: false,
        },
        isOpenAddInsuranceModal: false,
        deviceNamesList: [],
        isRedirectedFromDemographics: false,
        editDemographicsData: {},
        deviceTestList: [],
        transactionIdAndAadhaar: null,
        createABHAPatientResponse: {},
        openImportABHADetailsModal:false,
        openGetOrCreatePatientModal:"",
        isCreateABHA:false,
        openValidateGetOtpModal : false,
        openValidateCreateOtpModal:false,
        openSelectPatientModal:false,
        patientsList:null,
        clearOtpOrMobile:false,
        openUpdateABHAValidateOtpModal:false,
        patientDetailsReviewLocation:"",
        openABHACreateSuccessPopup:false,
        startTimer: false,
        createPatientFromAadhaar:"",
        abhaSuggestedAddress:"",
        abhaSuggestionsOpen: false,
        abhaAddressUpdateOpen:false,
        selectedABHAAddress:"",
        updatedABHAEmail:"",
        updatedABHAMobile:"",
        abhaProfilePicture: null,
        downloadedCardBuffer: null,
        selectedABHAOption:"",
        selectedPatient:null,
        showValidateMobileModal:false,
        mobileNumberToLink:null,
        isVerified:false,
        showChooseAbhaAddressModal:false,
        openConsentForm:false,
        adhaarOtpMsg:"",
        createPatientFromScanAndShareProviderId:"",
        captchaData: {},
        isAddharExist:false,
    }
})

export const { 
    setCreatePatientData, 
    setIsAadharProvided, 
    setProviderGroupLocation, 
    setEmergencyContact, 
    setInsurance, 
    setPreferencesOptions, 
    setIsOpenAddCenterModal, 
    setCreatePatientSuccessData, 
    setNewlyAddedPatientId, 
    setFetchedPatientDetails, 
    setIsFormSubmitted, 
    setFetchedEmergencyContactDetails, 
    setIsOpenAddInsuranceModal, 
    setDeviceNamesList, 
    setIsRedirectedFromDemographics, 
    setEditDemographicsData, 
    setDeviceTestList, 
    setTransactionIdAndAadhaar, 
    setCreateABHApatientRespose,
    setOpenImportABHADetailsModal, 
    setOpenGetOrCreatePatientModal, 
    setIsCreateABHA, 
    setOpenValidateGetOtpModal, 
    setOpenValidateCreateOtpModal, 
    setOpenSelectPatientModal, 
    setPatientsList, 
    setClearOtpOrMobile, 
    setOpenUpdateABHAValidateOtpModal, 
    setOpenABHACreateSuccessPopup, 
    setPatientDetailsReviewLocation, 
    setStartTimer, 
    setCreatePatientFromAadhaar, 
    setABHAsuggestedAddress, 
    setABHASuggestionsOpen, 
    setABHAAddressUpdateOpen, 
    setSelectedABHAAddress, 
    setUpdatedABHAMobile, 
    setUpdatedABHAEmail, 
    setABHAProfilePicture, 
    setDownloadedCard,
    setSelectedABHAOption,
    setSelectedPatient,
    setShowValidateMobileModal,
    setMobileNumberToLink,
    setIsVerified,
    setShowChooseAbhaAddressModal,
    setOpenConsentForm,
    setAdhaarOtpMsg,
    setScanAndShareProviderId,
    setCaptchaData,
    setIsAadharExist
} = actions
